import { useState } from 'react';
import { useIntl } from 'react-intl';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import Styles from './styles.module.css';
import Button from '../../shared/ui/button/button';
import googleLigthImg from '../../shared/assets/brand/googleLogo.png';
import { useAuth } from '../../context/AuthContext';
import { firebaseApp } from './firebase';

export const FirebaseGoogleSignIn = ({
	onMfaRequired,
	isInAppBrowser,
	onInAppBrowserGoogleClick,
}) => {
	const intl = useIntl();
	const { googleAuth } = useAuth();
	const navigate = useNavigate();
	const auth = getAuth(firebaseApp);
	const provider = new GoogleAuthProvider();
	provider.setCustomParameters({ prompt: 'select_account' });
	const [isLoading, setIsLoading] = useState(false);

	const handleLogin = async () => {
		if (isInAppBrowser && onInAppBrowserGoogleClick) {
			return onInAppBrowserGoogleClick();
		}
		try {
			setIsLoading(true);
			const result = await signInWithPopup(auth, provider);

			const user = result.user;
			const userData = {
				id_token: user.accessToken,
			};

			const response = await googleAuth(userData);

			// Check if MFA is required - delegate to parent so MFA uses same separate page as email login
			if (response && response.requires_mfa) {
				onMfaRequired?.({
					temp_token: response.temp_token,
					mfa_type: response.mfa_type,
					user: response.user,
					authProvider: 'google',
				});
				setIsLoading(false);
				return;
			}

			// Only navigate if authentication was successful
			if (response && typeof response === 'string') {
				navigate('/overview');
			}
		} catch (error) {
			console.error('Firebase login failed:', error);
			setIsLoading(false);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div>
			<Button
				variant='secondary'
				fullWidth
				className={Styles.googleButton}
				onClick={handleLogin}
				loading={isLoading}
			>
				<img src={googleLigthImg} alt='' className={Styles.googleMark} />
				{isLoading
					? intl.formatMessage({ id: 'AuthId5' })
					: intl.formatMessage({ id: 'AuthId4' })}
			</Button>
		</div>
	);
};
